module.exports = __webpack_public_path__ + "img/PXioNf1l-EmRPaQ,UPRAWN_UDT_Bielsko_Biala_dot_wytw_elementow_urz_cisn_i_bezcisn_VI_2015.780a7f57.jpeg";